import { render, staticRenderFns } from "./verFacturasPendientesView.vue?vue&type=template&id=53f7ce42"
import script from "./verFacturasPendientesView.vue?vue&type=script&lang=js"
export * from "./verFacturasPendientesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports